import { Component } from '@angular/core';
import { App } from 'ionic-angular';
import { NavController, NavParams, LoadingController, Events } from 'ionic-angular';


import { User } from '../../providers/providers';

const url = 'http://cdn.chitika.net/getads.js';

@Component({
  templateUrl: 'privacy-policy.html'
})
export class PrivacyPolicyPage {  

    //loadAPI: Promise<any>;
    //public placement_id:number;
    //public bannerId:string = "not set";

    constructor(
        public navCtrl: NavController,
        public navParams:NavParams,
        public loadingCtrl: LoadingController,
        public events:Events) {
          
      } 

      /*chitikaAddHeight(){
        if (window['CHITIKA'] === undefined) { window['CHITIKA'] = { 'units' : [] }; };
              var unit = {"calltype":"async[2]","publisher":"picladder","width":320,"height":50,"sid":"Chitika Default"};
              this.placement_id = window['CHITIKA'].units.length;
              window['CHITIKA'].units.push(unit);
              this.bannerId = "chitikaAdBlock-"+this.placement_id.toString();
              //document.write('<div id="chitikaAdBlock-' + this.placement_id + '"></div>');
      }
    
      ngOnInit(){
        this.loadAPI = new Promise((resolve) => {
            console.log('resolving promise...');
            this.loadScript();
        });
    }
    
    public loadScript() {
        console.log('preparing to load...')
        let node = document.createElement('script');
        node.src = url;
        node.type = 'text/javascript';
        node.async = true;
        node.charset = 'utf-8';
        document.getElementsByTagName('head')[0].appendChild(node);
        this.chitikaAddHeight();
    }
 */

}



// WEBPACK FOOTER //
// ./src/pages/privacy-policy/privacy-policy.ts